<template>
    <div>
        <top-users-chart-filter :action="filterAction"></top-users-chart-filter>
        <core-top-users-chart :key="component_key+'count'" :query="query"></core-top-users-chart>
        <core-top-users-amount-chart :key="component_key+'amount'" :query="query"></core-top-users-amount-chart>
        <core-top-users-wage-chart :key="component_key+'wage'" :query="query" v-if="$can('read-wages', 'transaction')"></core-top-users-wage-chart>
    </div>
</template>

<script>
import CoreTopUsersChart from "@/views/reports/components/core-top-users-chart.vue";
import CoreTopUsersAmountChart from "@/views/reports/components/core-top-users-amount-chart.vue";
import CoreTopUsersWageChart from "@/views/reports/components/core-top-users-wage-chart.vue";
import TopUsersChartFilter from "@/views/reports/components/top-users-chart-filter.vue";

export default {
    name: "topUsersChart",
    components: {CoreTopUsersChart, CoreTopUsersAmountChart, CoreTopUsersWageChart, TopUsersChartFilter},
    data() {
        return {
            query : {
                count_of_users: 30,
                count_of_days: 10,
                user_name: null,
            },
            component_key : 0
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            this.component_key++
        },
    }
}

</script>

<style scoped>
</style>
